import { isDefined } from '@sgme/fp';
import { Tooltip } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField';
import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { selectForwardAccumulatorProperty } from '@/store/forwardAccumulator/selectors.ts';
import { type AccumulatorAmountMode, accumulatorAmountModes } from '@/store/forwardAccumulator/state.ts';
import { useAppSelector } from '@/store/hooks.ts';

const AmountMode = () => {
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();
  const amountMode = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'amountMode'));
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleAmountMode = (event: React.ChangeEvent<HTMLSelectElement>) => {
    sgwtWebAnalytics?.trackEvent(
      'Forward Accumulator',
      'Amount mode changed',
      isDefined(event.target.value) ? event.target.value : 'cleared',
    );

    return check({
      amountMode: event.target.value as AccumulatorAmountMode,
    });
  };

  return (
    <FormField
      formattedMessageId="forwardAccumulator.form.amountMode"
      extra={
        <Tooltip position="right" contents={<FormattedMessage id="forwardAccumulator.form.amountMode.info" />}>
          <div className="badge badge-dismissible">
            <em className="icon icon-sm cursor-default line-height-1 text-secondary">info_outline</em>
          </div>
        </Tooltip>
      }
    >
      <Form.Select value={amountMode} onChange={handleAmountMode} size="sm" data-e2e="amount-mode-selector">
        {accumulatorAmountModes.map((mode) => (
          <option key={mode} value={mode}>
            <FormattedMessage id={`forwardAccumulator.form.amountMode.${mode}`} />
          </option>
        ))}
      </Form.Select>
    </FormField>
  );
};

export default AmountMode;
